import type { DxTradeOrder, DxTradeOrderCashTransaction } from '@model/DxTrade.types'
import { DxTradeCashTransactionTypes } from '@model/DxTrade.types'

export interface OrderCashAdjustmentsResult {
  commission?: { total: number; currency: string | null }
  financing?: { total: number; currency: string | null }
}

export function useDxtradeOrderCashAdjustments(order?: DxTradeOrder): OrderCashAdjustmentsResult {
  const all = order?.cashTransactions ?? []

  const aggregate = (list: DxTradeOrderCashTransaction[]) => {
    if (!list.length) return undefined
    if (list.length === 1) {
      const transaction = list[0]
      return { total: transaction.value ?? 0, currency: transaction.currency }
    }
    const total = list.reduce((acc, transaction) => acc + (transaction.value ?? 0), 0)
    const currencySet = new Set(list.map((transaction) => transaction.currency).filter(Boolean))
    const currency = currencySet.size === 1 ? list[0].currency : null
    return { total, currency }
  }

  const commission = aggregate(all.filter((t) => t.type === DxTradeCashTransactionTypes.COMMISSION))

  return { commission }
}
